const country = [
  { key: 'AFG', value: 'Afganistán' },
  { key: 'ALA', value: 'Islas Åland' },
  { key: 'ALB', value: 'Albania' },
  { key: 'DEU', value: 'Alemania' },
  { key: 'AND', value: 'Andorra' },
  { key: 'AGO', value: 'Angola' },
  { key: 'AIA', value: 'Anguila' },
  { key: 'ATA', value: 'Antártida' },
  { key: 'ATG', value: 'Antigua y Barbuda' },
  { key: 'SAU', value: 'Arabia Saudita' },
  { key: 'DZA', value: 'Argelia' },
  { key: 'ARG', value: 'Argentina' },
  { key: 'ARM', value: 'Armenia' },
  { key: 'ABW', value: 'Aruba' },
  { key: 'AUS', value: 'Australia' },
  { key: 'AUT', value: 'Austria' },
  { key: 'AZE', value: 'Azerbaiyán' },
  { key: 'BHS', value: 'Bahamas (las)' },
  { key: 'BGD', value: 'Bangladés' },
  { key: 'BRB', value: 'Barbados' },
  { key: 'BHR', value: 'Baréin' },
  { key: 'BEL', value: 'Bélgica' },
  { key: 'BLZ', value: 'Belice' },
  { key: 'BEN', value: 'Benín' },
  { key: 'BMU', value: 'Bermudas' },
  { key: 'BLR', value: 'Bielorrusia' },
  { key: 'MMR', value: 'Myanmar' },
  { key: 'BOL', value: 'Bolivia, Estado Plurinacional de' },
  { key: 'BIH', value: 'Bosnia y Herzegovina' },
  { key: 'BWA', value: 'Botsuana' },
  { key: 'BRA', value: 'Brasil' },
  { key: 'BRN', value: 'Brunéi Darussalam' },
  { key: 'BGR', value: 'Bulgaria' },
  { key: 'BFA', value: 'Burkina Faso' },
  { key: 'BDI', value: 'Burundi' },
  { key: 'BTN', value: 'Bután' },
  { key: 'CPV', value: 'Cabo Verde' },
  { key: 'KHM', value: 'Camboya' },
  { key: 'CMR', value: 'Camerún' },
  { key: 'CAN', value: 'Canadá' },
  { key: 'QAT', value: 'Catar' },
  { key: 'BES', value: 'Bonaire, San Eustaquio y Saba' },
  { key: 'TCD', value: 'Chad' },
  { key: 'CHL', value: 'Chile' },
  { key: 'CHN', value: 'China' },
  { key: 'CYP', value: 'Chipre' },
  { key: 'COL', value: 'Colombia' },
  { key: 'COM', value: 'Comoras' },
  { key: 'PRK', value: 'Corea (la República Democrática Popular de)' },
  { key: 'KOR', value: 'Corea (la República de)' },
  { key: 'CIV', value: 'Côte d\'Ivoire' },
  { key: 'CRI', value: 'Costa Rica' },
  { key: 'HRV', value: 'Croacia' },
  { key: 'CUB', value: 'Cuba' },
  { key: 'CUW', value: 'Curaçao' },
  { key: 'DNK', value: 'Dinamarca' },
  { key: 'DMA', value: 'Dominica' },
  { key: 'ECU', value: 'Ecuador' },
  { key: 'EGY', value: 'Egipto' },
  { key: 'SLV', value: 'El Salvador' },
  { key: 'ARE', value: 'Emiratos Árabes Unidos (Los)' },
  { key: 'ERI', value: 'Eritrea' },
  { key: 'SVK', value: 'Eslovaquia' },
  { key: 'SVN', value: 'Eslovenia' },
  { key: 'ESP', value: 'España' },
  { key: 'USA', value: 'Estados Unidos (los)' },
  { key: 'EST', value: 'Estonia' },
  { key: 'ETH', value: 'Etiopía' },
  { key: 'PHL', value: 'Filipinas (las)' },
  { key: 'FIN', value: 'Finlandia' },
  { key: 'FJI', value: 'Fiyi' },
  { key: 'FRA', value: 'Francia' },
  { key: 'GAB', value: 'Gabón' },
  { key: 'GMB', value: 'Gambia (La)' },
  { key: 'GEO', value: 'Georgia' },
  { key: 'GHA', value: 'Ghana' },
  { key: 'GIB', value: 'Gibraltar' },
  { key: 'GRD', value: 'Granada' },
  { key: 'GRC', value: 'Grecia' },
  { key: 'GRL', value: 'Groenlandia' },
  { key: 'GLP', value: 'Guadalupe' },
  { key: 'GUM', value: 'Guam' },
  { key: 'GTM', value: 'Guatemala' },
  { key: 'GUF', value: 'Guayana Francesa' },
  { key: 'GGY', value: 'Guernsey' },
  { key: 'GIN', value: 'Guinea' },
  { key: 'GNB', value: 'Guinea-Bisáu' },
  { key: 'GNQ', value: 'Guinea Ecuatorial' },
  { key: 'GUY', value: 'Guyana' },
  { key: 'HTI', value: 'Haití' },
  { key: 'HND', value: 'Honduras' },
  { key: 'HKG', value: 'Hong Kong' },
  { key: 'HUN', value: 'Hungría' },
  { key: 'IND', value: 'India' },
  { key: 'IDN', value: 'Indonesia' },
  { key: 'IRQ', value: 'Irak' },
  { key: 'IRN', value: 'Irán (la República Islámica de)' },
  { key: 'IRL', value: 'Irlanda' },
  { key: 'BVT', value: 'Isla Bouvet' },
  { key: 'IMN', value: 'Isla de Man' },
  { key: 'CXR', value: 'Isla de Navidad' },
  { key: 'NFK', value: 'Isla Norfolk' },
  { key: 'ISL', value: 'Islandia' },
  { key: 'CYM', value: 'Islas Caimán (las)' },
  { key: 'CCK', value: 'Islas Cocos (Keeling)' },
  { key: 'COK', value: 'Islas Cook (las)' },
  { key: 'FRO', value: 'Islas Feroe (las)' },
  { key: 'SGS', value: 'Georgia del sur y las islas sandwich del sur' },
  { key: 'HMD', value: 'Isla Heard e Islas McDonald' },
  { key: 'FLK', value: 'Islas Malvinas [Falkland] (las)' },
  { key: 'MNP', value: 'Islas Marianas del Norte (las)' },
  { key: 'MHL', value: 'Islas Marshall (las)' },
  { key: 'PCN', value: 'Pitcairn' },
  { key: 'SLB', value: 'Islas Salomón (las)' },
  { key: 'TCA', value: 'Islas Turcas y Caicos (las)' },
  { key: 'UMI', value: 'Islas de Ultramar Menores de Estados Unidos (las)' },
  { key: 'VGB', value: 'Islas Vírgenes (Británicas)' },
  { key: 'VIR', value: 'Islas Vírgenes (EE.UU.)' },
  { key: 'ISR', value: 'Israel' },
  { key: 'ITA', value: 'Italia' },
  { key: 'JAM', value: 'Jamaica' },
  { key: 'JPN', value: 'Japón' },
  { key: 'JEY', value: 'Jersey' },
  { key: 'JOR', value: 'Jordania' },
  { key: 'KAZ', value: 'Kazajistán' },
  { key: 'KEN', value: 'Kenia' },
  { key: 'KGZ', value: 'Kirguistán' },
  { key: 'KIR', value: 'Kiribati' },
  { key: 'KWT', value: 'Kuwait' },
  { key: 'LAO', value: 'Lao, (la) República Democrática Popular' },
  { key: 'LSO', value: 'Lesoto' },
  { key: 'LVA', value: 'Letonia' },
  { key: 'LBN', value: 'Líbano' },
  { key: 'LBR', value: 'Liberia' },
  { key: 'LBY', value: 'Libia' },
  { key: 'LIE', value: 'Liechtenstein' },
  { key: 'LTU', value: 'Lituania' },
  { key: 'LUX', value: 'Luxemburgo' },
  { key: 'MAC', value: 'Macao' },
  { key: 'MDG', value: 'Madagascar' },
  { key: 'MYS', value: 'Malasia' },
  { key: 'MWI', value: 'Malaui' },
  { key: 'MDV', value: 'Maldivas' },
  { key: 'MLI', value: 'Malí' },
  { key: 'MLT', value: 'Malta' },
  { key: 'MAR', value: 'Marruecos' },
  { key: 'MTQ', value: 'Martinica' },
  { key: 'MUS', value: 'Mauricio' },
  { key: 'MRT', value: 'Mauritania' },
  { key: 'MYT', value: 'Mayotte' },
  { key: 'MEX', value: 'México' },
  { key: 'FSM', value: 'Micronesia (los Estados Federados de)' },
  { key: 'MDA', value: 'Moldavia (la República de)' },
  { key: 'MCO', value: 'Mónaco' },
  { key: 'MNG', value: 'Mongolia' },
  { key: 'MNE', value: 'Montenegro' },
  { key: 'MSR', value: 'Montserrat' },
  { key: 'MOZ', value: 'Mozambique' },
  { key: 'NAM', value: 'Namibia' },
  { key: 'NRU', value: 'Nauru' },
  { key: 'NPL', value: 'Nepal' },
  { key: 'NIC', value: 'Nicaragua' },
  { key: 'NER', value: 'Níger (el)' },
  { key: 'NGA', value: 'Nigeria' },
  { key: 'NIU', value: 'Niue' },
  { key: 'NOR', value: 'Noruega' },
  { key: 'NCL', value: 'Nueva Caledonia' },
  { key: 'NZL', value: 'Nueva Zelanda' },
  { key: 'OMN', value: 'Omán' },
  { key: 'NLD', value: 'Países Bajos (los)' },
  { key: 'PAK', value: 'Pakistán' },
  { key: 'PLW', value: 'Palaos' },
  { key: 'PSE', value: 'Palestina, Estado de' },
  { key: 'PAN', value: 'Panamá' },
  { key: 'PNG', value: 'Papúa Nueva Guinea' },
  { key: 'PRY', value: 'Paraguay' },
  { key: 'PER', value: 'Perú' },
  { key: 'PYF', value: 'Polinesia Francesa' },
  { key: 'POL', value: 'Polonia' },
  { key: 'PRT', value: 'Portugal' },
  { key: 'PRI', value: 'Puerto Rico' },
  { key: 'GBR', value: 'Reino Unido (el)' },
  { key: 'CAF', value: 'República Centroafricana (la)' },
  { key: 'CZE', value: 'República Checa (la)' },
  { key: 'MKD', value: 'Macedonia (la antigua República Yugoslava de)' },
  { key: 'COG', value: 'Congo' },
  { key: 'COD', value: 'Congo (la República Democrática del)' },
  { key: 'DOM', value: 'República Dominicana (la)' },
  { key: 'REU', value: 'Reunión' },
  { key: 'RWA', value: 'Ruanda' },
  { key: 'ROU', value: 'Rumania' },
  { key: 'RUS', value: 'Rusia, (la) Federación de' },
  { key: 'ESH', value: 'Sahara Occidental' },
  { key: 'WSM', value: 'Samoa' },
  { key: 'ASM', value: 'Samoa Americana' },
  { key: 'BLM', value: 'San Bartolomé' },
  { key: 'KNA', value: 'San Cristóbal y Nieves' },
  { key: 'SMR', value: 'San Marino' },
  { key: 'MAF', value: 'San Martín (parte francesa)' },
  { key: 'SPM', value: 'San Pedro y Miquelón' },
  { key: 'VCT', value: 'San Vicente y las Granadinas' },
  { key: 'SHN', value: 'Santa Helena, Ascensión y Tristán de Acuña' },
  { key: 'LCA', value: 'Santa Lucía' },
  { key: 'STP', value: 'Santo Tomé y Príncipe' },
  { key: 'SEN', value: 'Senegal' },
  { key: 'SRB', value: 'Serbia' },
  { key: 'SYC', value: 'Seychelles' },
  { key: 'SLE', value: 'Sierra leona' },
  { key: 'SGP', value: 'Singapur' },
  { key: 'SXM', value: 'Sint Maarten (parte holandesa)' },
  { key: 'SYR', value: 'Siria, (la) República Árabe' },
  { key: 'SOM', value: 'Somalia' },
  { key: 'LKA', value: 'Sri Lanka' },
  { key: 'SWZ', value: 'Suazilandia' },
  { key: 'ZAF', value: 'Sudáfrica' },
  { key: 'SDN', value: 'Sudán (el)' },
  { key: 'SSD', value: 'Sudán del Sur' },
  { key: 'SWE', value: 'Suecia' },
  { key: 'CHE', value: 'Suiza' },
  { key: 'SUR', value: 'Surinam' },
  { key: 'SJM', value: 'Svalbard y Jan Mayen' },
  { key: 'THA', value: 'Tailandia' },
  { key: 'TWN', value: 'Taiwán (Provincia de China)' },
  { key: 'TZA', value: 'Tanzania, República Unida de' },
  { key: 'TJK', value: 'Tayikistán' },
  { key: 'IOT', value: 'Territorio Británico del Océano Índico (el)' },
  { key: 'ATF', value: 'Territorios Australes Franceses (los)' },
  { key: 'TLS', value: 'Timor-Leste' },
  { key: 'TGO', value: 'Togo' },
  { key: 'TKL', value: 'Tokelau' },
  { key: 'TON', value: 'Tonga' },
  { key: 'TTO', value: 'Trinidad y Tobago' },
  { key: 'TUN', value: 'Túnez' },
  { key: 'TKM', value: 'Turkmenistán' },
  { key: 'TUR', value: 'Turquía' },
  { key: 'TUV', value: 'Tuvalu' },
  { key: 'UKR', value: 'Ucrania' },
  { key: 'UGA', value: 'Uganda' },
  { key: 'URY', value: 'Uruguay' },
  { key: 'UZB', value: 'Uzbekistán' },
  { key: 'VUT', value: 'Vanuatu' },
  { key: 'VAT', value: 'Santa Sede[Estado de la Ciudad del Vaticano] (la)' },
  { key: 'VEN', value: 'Venezuela, República Bolivariana de' },
  { key: 'VNM', value: 'Viet Nam' },
  { key: 'WLF', value: 'Wallis y Futuna' },
  { key: 'YEM', value: 'Yemen' },
  { key: 'DJI', value: 'Yibuti' },
  { key: 'ZMB', value: 'Zambia' },
  { key: 'ZWE', value: 'Zimbabue' },
  { key: 'ZZZ', value: 'Países no declarados' },
];

module.exports = country;
